<template>
  <div>
    <List v-if="event.id !== undefined">
      <div class="item">
        <div clas="item-left">
          {{ $l.eventName }}
        </div>
        <div clas="item-left">
          {{ event.get('name') }}
        </div>
      </div>

      <div class="item">
        <div clas="item-left">
          {{ $l.eventDate }}
        </div>
        <div clas="item-left">
          {{ eventDateTime }}
        </div>
      </div>

      <div class="item">
        <div clas="item-left">
          {{ $l.eventPlace }}
        </div>
        <div clas="item-left">
          {{ event.get('place') }}
        </div>
      </div>

      <div class="item">
        <div clas="item-left">
          {{ $l.eventContent }}
        </div>
        <div clas="item-left">
          {{ event.get('content') }}
        </div>
      </div>

      <button-entried v-if="hasEntried" />
      <button-entry v-else />
    </List>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { format } from 'date-fns'
import Parse from 'parse'

import MixinLocale from '@/components/MixinLocale'
import List from '@/components/List'
import ButtonEntry from '@/components/Event/ButtonEntry'
// import ButtonCancel from '@/components/Event/ButtonCancel'
import ButtonEntried from '@/components/Event/ButtonEntried'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    List,
    ButtonEntry,
    // ButtonCancel
    ButtonEntried
  },

  created: async function () {
    this.fetchEvent()
    this.$store.dispatch('entry/fetchEntry')
  },

  computed: {
    ...mapState('event', {
      event: 'selected'
    }),

    ...mapState('entry', [
      'entry'
    ]),

    eventDateTime: function () {
      const date = format(this.event.get('date'), 'YYYY年 M月 D日')
      return date + ' ' + this.event.get('start') + ' ~ ' + this.event.get('finish')
    },

    hasEntried: function () {
      if (!this.entry) {
        return false
      }
      return this.entry.get('event').id === this.event.id
    }
  },

  methods: {
    fetchEvent: async function () {
      const query = new Parse.Query('Event')
      const event = await query.get(this.$route.params.id)
      this.$store.commit('event/setSelected', event)
    }
  }
}
</script>
